import { VisibilityOffIcon, VisibilityOnIcon } from 'ui/src/icons/utility'
import { PasswordVisibilityClassname } from './sc'

const iconProps = {
    width: 20,
    height: 20,
    style: { display: 'inline' },
}
type Props = {
    ariaLabel?: string
    viewPassword: boolean
    setViewPassword: (viewPassword: boolean) => void
}

const defaultAriaLabel = 'Show password as plain text. Warning: this will display your password on the screen.'

const PasswordVisibility = ({ ariaLabel = defaultAriaLabel, setViewPassword, viewPassword }: Props) => {
    return (
        <i
            className={PasswordVisibilityClassname}
            onClick={() => setViewPassword(!viewPassword)}
            aria-label={ariaLabel}
        >
            {viewPassword ? <VisibilityOnIcon {...iconProps} /> : <VisibilityOffIcon {...iconProps} />}
        </i>
    )
}

export default PasswordVisibility
